var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 20,
    viewBox: "0 0 4 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23489",
    "data-name": "Group 23489",
    transform: "translate(-18 -10)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_357",
    "data-name": "Ellipse 357",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(18 10)",
    fill: "#0c66e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_358",
    "data-name": "Ellipse 358",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(18 18)",
    fill: "#0c66e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_359",
    "data-name": "Ellipse 359",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(18 26)",
    fill: "#0c66e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.9334b01f36bb10f4f43930e9116c5a77.svg";
export { ForwardRef as ReactComponent };